export default {"src":"/sitetest/_next/static/media/first_nav_icon03.ae8b10e4.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};